import { ResponsiveModal } from "@components/responsive-modal";
import { LorasType } from "@features/loras/type";
import { useTranslation } from "react-i18next";
import { useQuery, useQueryClient } from "react-query";
import { LoraSearchModelContent } from "./search-lora-model-content";
import { LoraSearchStyleContent } from "./search-lora-style-content";

export const useLoraSearchModal = () => {
  const queryClient = useQueryClient();
  const isOpen = useQuery<{
    open: false | "styles" | "models";
    cb?: (id: string, model: LorasType) => void;
  }>(
    ["lora-search-modal"],
    () => {
      return { open: false };
    },
    { enabled: false }
  );

  return {
    open: isOpen.data?.open,
    cb: isOpen.data?.cb,
    setOpen: (
      open: false | "styles" | "models",
      cb?: (id: string, model: LorasType) => void
    ) => {
      queryClient.setQueryData(["lora-search-modal"], { open, cb });
    },
  };
};

export const LoraSearchModal = () => {
  const { open, cb, setOpen } = useLoraSearchModal();
  const { t } = useTranslation();

  return (
    <ResponsiveModal
      isOpen={!!open}
      onClose={() => setOpen(false)}
      title={t("search.search_library", "Search Library")}
      height="auto"
      maxHeight="90vh"
    >
      {open === "models" && (
        <LoraSearchModelContent
          onSelect={() => setOpen(false)}
          onNavigate={cb}
        />
      )}
      {open === "styles" && (
        <LoraSearchStyleContent
          onSelect={() => setOpen(false)}
          onNavigate={cb}
        />
      )}
    </ResponsiveModal>
  );
};
